export const genericErrorMessage = 'An unexpected error occurred.'
